/**
 * 1. Groups Dawn's native quantity selector and "Add to cart" button into
 *    one row (buy-box-style.css styles that row as two pills side by
 *    side). Dawn renders the quantity selector and the buy-buttons block
 *    as two separate sibling elements, so this moves them into a shared
 *    wrapper rather than requiring changes to Dawn's own buy-buttons
 *    snippet. The "Add to cart" button already carries a form="..."
 *    attribute (Dawn's own doing, same as the quantity input), so moving
 *    it in the DOM does not break the add-to-cart submit.
 *
 * 2. Wires up the custom "Buy Now" button(s) rendered by the Buy Now
 *    Button block: adds the current variant/quantity to the cart via
 *    the Ajax Cart API, then redirects straight to checkout. This is a
 *    plain button rather than Shopify's dynamic-checkout widget, so its
 *    look is fully controlled by the block's own settings; it can't
 *    rely on a native form submit because Dawn's own product-form.js
 *    already intercepts the form's submit event to add to cart via
 *    fetch instead of a normal page post.
 */
(function () {
  'use strict';

  groupQuantityWithAddToCart();
  setupBuyNowButtons();

  function groupQuantityWithAddToCart() {
    var quantityForms = document.querySelectorAll('[id^="Quantity-Form-"]');

    quantityForms.forEach(function (qtyForm) {
      if (qtyForm.closest('.buy-box-row')) return; // already grouped

      var scope = qtyForm.closest('.product__info-container') || document;
      var addToCartBtn = scope.querySelector('.product-form__submit');
      if (!addToCartBtn) return;

      var row = document.createElement('div');
      row.className = 'buy-box-row';
      qtyForm.parentNode.insertBefore(row, qtyForm);
      row.appendChild(qtyForm);
      row.appendChild(addToCartBtn);
    });
  }

  function setupBuyNowButtons() {
    var buttons = document.querySelectorAll('.custom-buy-now-btn');

    buttons.forEach(function (btn) {
      if (btn.dataset.buyNowBound) return;
      btn.dataset.buyNowBound = 'true';

      btn.addEventListener('click', function () {
        // Read straight from the page's hidden variant-id input and any
        // quantity input present, rather than requiring a specific
        // <form> to be found first — this is the same approach the
        // "Add To Cart Row" block uses, and it works regardless of
        // whether Dawn's own quantity_selector/buy_buttons blocks are
        // on the page at all.
        var idInput = document.querySelector('input[name="id"]');
        var qtyInput = document.querySelector('input[name="quantity"], [data-qty-input]');
        var variantId = idInput ? idInput.value : null;
        var quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

        if (!variantId) {
          window.alert('Please select an option first.');
          return;
        }

        var originalText = btn.textContent;
        btn.disabled = true;
        btn.textContent = '...';

        var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

        fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: quantity }),
        })
          .then(function (res) {
            return res.json().then(function (data) {
              if (!res.ok) throw new Error(data.description || 'Could not add to cart');
              return data;
            });
          })
          .then(function () {
            window.location.href = root + 'checkout';
          })
          .catch(function (err) {
            console.error('Buy Now failed:', err);
            btn.disabled = false;
            btn.textContent = originalText;
            window.alert('Sorry, something went wrong adding this to your cart. Please try Add to Cart instead.');
          });
      });
    });
  }
})();